import { firestore, collection, query, where, getDocs, addDoc, doc, updateDoc } from "../firebase/firebaseConfig";


export const fetchGlobalNotifications = async () => {
  const notificationsRef = collection(firestore, "notifications");
  const q = query(notificationsRef, where("isGlobal", "==", true));
  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const fetchUserNotifications = async (userId) => {
  const userNotificationsRef = collection(firestore, "user_profiles", userId, "notifications");
  const snapshot = await getDocs(userNotificationsRef);

  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const updateNotificationStatus = async (userId, notificationId, status) => {
  try {
    const notificationRef = doc(firestore, "user_profiles", userId, "notifications", notificationId);

    await updateDoc(notificationRef, {
      status,
      updatedAt: new Date(),
    });

    console.log(`✅ Notification ${notificationId} marked as ${status}`);
  } catch (error) {
    console.error("❌ Error updating notification status:", error);
  }
};

/**
 * Sends a notification when a user receives a bonus free trade.
 * @param {string} userId - The ID of the user receiving the free trade.
 * @param {number} freeTrades - The total free trades the user now has.
 */
export const sendFreeTradeNotification = async (userId, freeTrades) => {
  try {
    if (!userId) throw new Error("User ID is required for notifications.");

    // Reference to user notifications subcollection
    const userNotificationsRef = collection(firestore, "user_profiles", userId, "notifications");

    // Check if a free trade notification already exists to prevent duplicates
    const existingQuery = query(userNotificationsRef, where("type", "==", "free_trade_awarded"));
    const existingNotifications = await getDocs(existingQuery);

    if (existingNotifications.empty) {
      // Add a notification for the free trade
      await addDoc(userNotificationsRef, {
        title: "🎉 Bonus Free Trade Awarded!",
        message: `You've received a bonus free trade! You now have ${freeTrades} total free trades available.`,
        type: "free_trade_awarded",
        alertStatus: "success",
        createdAt: new Date(),
        status: "unread",
      });

      console.log("✅ Free trade notification sent.");
    } else {
      console.log("ℹ️ Free trade notification already exists, skipping duplicate.");
    }
  } catch (error) {
    console.error("❌ Error sending free trade notification:", error.message);
  }
};


export const addKYCNotificationIfNeeded = async (userId) => {
  const notifRef = collection(firestore, "user_profiles", userId, "notifications");
  const existingQuery = query(notifRef, where("type", "==", "kyc_verification_needed"));
  const existing = await getDocs(existingQuery);

  if (existing.empty) {
    await addDoc(notifRef, {
      title: "KYC Verification Required",
      message: "Please complete your KYC verification to access full platform features.",
      type: "kyc_verification_needed",
      alertStatus: "warning",
      action: { label: "Verify Now", url: "/personal/doc-info" },
      createdAt: new Date(),
      status: "unread",
    });
  }
};